<script>
import OrdersList from "@/components/orderslist"
import CountriesApi from "@/services/countries-api";

export default {
  props: {
  propShowDrafts: {
    type: Boolean,
    default:  false,
  },
},


  mounted(){
      this.getCountries();

      if(this.endDate && this.startDate){
        this.end = this.endDate,
        this.start = this.startDate
      }

  },

  components: { OrdersList },
  data() {
    return {
      selected:null,
      selectedState:[],
      status:null,
      selectedPointingState:null,
      pointingState:null,
      customersList:[],
      citiesList:[],
      countriesList:[],
      selectedCountry:null,
      selectedCity:null,
      selectedCityId:null,
      selectedCountryId:null,
      selectedCustomer:null,
      end:null,
      start:null,
      showDrafts:null,
      exportOrdersInProgress: false,
      showUnsynchronisedOrders:null,
      deliveryModes: null ,
      selectedMode:null,
      selectedDeliveryModeId:null ,
      deliveryNote:null,
      orderNumber:null,

      filterByDeliveryNote:null,
      filterByOrderNumber:null,
      filterByPaymentMethode:null,
      stateOptionsList:[{name :this.$t('ordersMenu.statusLabel.pending'),value: 1},
                        {name :this.$t('ordersMenu.statusLabel.calledCustomer'), value: 2},
                        {name :this.$t('ordersMenu.statusLabel.beingPrepared'), value: 3},
                        {name :this.$t('ordersMenu.statusLabel.beingDelivered'), value: 4},
                        {name :this.$t('ordersMenu.statusLabel.delivered'), value: 5},
                        {name :this.$t('ordersMenu.statusLabel.canceled') + ' / Retour', value: 6}
                      ],


    };
  }, 
  methods:{

    getCountries(){
        CountriesApi.getCountries().then(
            result => {
                this.countriesList = result
            })
        },
        getCities(){
        CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : null).then(
            result => {
                this.citiesList = result
            })
        },

    setStatusToPending(value) {
      this.selectedState = [];
      if (value){
        value.forEach(v => 
      this.selectedState.push(this.stateOptionsList.find(option => option.value === v))
      ); 
      }

    },

    exportEXCEL(showDetails){
      this.exportOrdersInProgress = true;
      this.$refs.ordersList.exportOrdersListExcel(showDetails)
      .then(() => {
          this.exportOrdersInProgress = false;
      })
    },
    setDeliveryNote(){
      this.filterByDeliveryNote = this.deliveryNote ;
    },
    setOrderNumber(){
      this.filterByOrderNumber = this.orderNumber ;
    },

  },
    watch: {

      itemRef:function(){
        if(!this.itemRef || this.itemRef.trim() == ''){
          this.setItemRef()
        }
      },
      orderNumber:function(){
        if(!this.orderNumber || this.orderNumber.trim() == ''){
          this.setOrderNumber()
        }
      },

      deliveryNote:function(){
        if(!this.deliveryNote || this.deliveryNote.trim() == ''){
          this.setDeliveryNote()
        }
      },


      startDate: function(){
        this.start = this.startDate
      },
      endDate: function(){
        this.end = this.endDate
      },

        selected: function() {
            this.selectedCustomer = this.selected ? this.selected.id : null
        },

        selectedMode: function() {
            this.selectedDeliveryModeId = this.selectedMode ? this.selectedMode.id : null
        },

        selectedState: function() {
            this.status = this.selectedState ? this.selectedState.map(state => state.value) : null
        },
        selectedPointingState: function() {
            this.pointingState = this.selectedPointingState ? this.selectedPointingState.value : null
        },
    }       
    }

</script>
<style>

</style>
<template>
      <div>
        
        <div  class="row mt-2">

          <div class="col-12 col-sm-6 col-lg-4 col-xl-2 pr-4">   
            <b-form-group :label="$t('lists.filterByOrder.label')" label-for="">
                <div class="row">
                  <div class="col-10">
                    <b-form-input v-model="orderNumber" :placeholder="$t('lists.filterByOrder.filter')"    @keyup.native.enter="setOrderNumber() "></b-form-input>
                  </div>
                  <div class="col-2">
                    <b-button variant="primary" size="sm"  class="p-2 float-left ml-1 " @click="setOrderNumber()" >
                        <i class="  fas fa-search font-size-16 font-weight-bold align-middle " ></i> 
                    </b-button>
                  </div>  
                </div>
            </b-form-group>
          </div>

          
          <div class="col-12 col-sm-6 col-lg-4 col-xl-2 pr-4" >
              <b-form-group :label="$t('lists.filterByDate.start')"  label-for="">
                <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </b-form-group>
          </div>

            <div class="col-12 col-sm-6 col-lg-4 col-xl-2 pr-4 " >
              <b-form-group :label="$t('lists.filterByDate.end')" label-for="">
                <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </b-form-group>
            </div>

            <div class="col-12 col-sm-6 col-lg-4 col-xl-2 pr-4">   
               <b-form-group :label="$t('lists.status.filter')" label-for="">
                  <v-select :options="stateOptionsList" 
                  :placeholder="$t('lists.status.label')" label="name" v-model="selectedState"  multiple :searchable="false">
                  <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                  </v-select>
              </b-form-group>
            </div>




        </div>  


        <OrdersList   ref="ordersList"
         @changeStatus="setStatusToPending"
          :isAllOrders="false" 
          :deliveryNote.sync=this.filterByDeliveryNote
          :orderNumber.sync=this.filterByOrderNumber
          :pointingState.sync=this.pointingState
          :showDrafts="showDrafts"
          :start=start 
          :status.sync=this.status
          :end=end 
          :selectedModeId.sync= this.selectedDeliveryModeId />

      </div>
</template>
